import { configRefs } from '@utils/constants';
import { authenticateComponentFrameworkRequest } from './util.authenticate-component-framework-request.js';

async function saveComponentEntry(user, entry) {
  const method = entry.envelope.objectID === undefined ? "POST" : "PUT";
  const url = entry.envelope.objectID === undefined ? `${await configRefs.apis.userdata.get()}/api/ComponentEntries` : `${await configRefs.apis.userdata.get()}/api/ComponentEntries/${encodeURIComponent(entry.envelope.objectID)}`;
  const requestBody = JSON.stringify({
    componentID: entry.envelope.componentID,
    componentType: entry.envelope.componentType,
    productID: entry.envelope.productID,
    userID: user?.id ?? "guest",
    userInstitutionID: user?.institution?.id,
    learningObject: entry.learningObject,
    title: entry.envelope.title,
    content: JSON.stringify(entry.data),
    readOnly: entry.envelope.readOnly,
    result: entry.envelope.result
  });
  const res = await fetch(...authenticateComponentFrameworkRequest(url, {
    method,
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: requestBody
  }));
  if (!res.ok) {
    throw new Error(`${res.status} ${res.statusText}: ${await res.text()}`);
  }
  const newEntry = {
    ...entry,
    envelope: {
      ...entry.envelope,
      modified: Date.now() / 1000
    }
  };
  if (method === "PUT") {
    return newEntry;
  }
  const response = await res.json();
  return {
    ...newEntry,
    envelope: {
      ...newEntry.envelope,
      objectID: response.objectID
    }
  };
}

export { saveComponentEntry };
//# sourceMappingURL=request.save-component-entry.js.map
